import React from 'react';
import './styles.scss';

const Footer = () => <footer className='footer'>I&apos;m the footer</footer>;

export default Footer;
